/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Pricing_Feat1Inputs */

const en_cp_pricing_feat1 = /** @type {(inputs: Cp_Pricing_Feat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14-week calendar + rubric`)
};

const id_cp_pricing_feat1 = /** @type {(inputs: Cp_Pricing_Feat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalender 14 minggu + rubrik`)
};

/**
* | output |
* | --- |
* | "14-week calendar + rubric" |
*
* @param {Cp_Pricing_Feat1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_pricing_feat1 = /** @type {((inputs?: Cp_Pricing_Feat1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Pricing_Feat1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_pricing_feat1(inputs)
	return en_cp_pricing_feat1(inputs)
});